// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const BaseCarousel = require('client-v2/common/components/carousels/base')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionSplitTrailingCarousel')


const slides = [
  /**
   * Slide images are assigned by index from the `img` directory:
   * `public/img/logged-out-landing/split-trailing-carousel/slide-${index}.jpg`
   */
  {
    // https://zpl.io/VqWNl9Y
    title: 'Find articles, images, videos, music',
    subtitle: 'Whether it’s on Mix or anywhere on the web.'
  },
  {
    // https://zpl.io/VDBLq7J
    title: 'Save them to a collection',
    subtitle: 'So you can view them later'
  },
  {
    // https://zpl.io/adpgr9e
    title: 'See what your friends are collecting',
    subtitle: 'Subscribe to their collections'
  }
]

function TopCallToActionSplitTrailingCarousel(props) {
  return tag('div', {
    className: classNames(
      props.className,
      bem.block()
    )
  },
    tag(BaseCarousel, {
      // Values
      autoplay: true,
      autoplayInterval: 4000,
      className: bem.element('slider'),
      transitionMode: 'fade',
      wrapAround: true,
      // Callbacks
      // The dots position changes based on responsive design
      renderBottomCenterControls: renderDots,
      renderCenterLeftControls: null,
      renderCenterRightControls: renderDots
    },
      slides.map(renderSlide)
    )
  )
}

TopCallToActionSplitTrailingCarousel.propTypes = {
  className: PropTypes.string
}

module.exports = TopCallToActionSplitTrailingCarousel

function renderDots(carouselProps) {
  return BaseCarousel.renderDots({ bemEntity: bem, ...carouselProps })
}

function renderSlide(slideProps, index) {
  return tag('div', {
    key: `slide:${index}`,
    className: bem.element('slide', { index })
  },
    tag('div', {
      className: bem.element('title')
    },
      slideProps.title
    ),
    tag('div', {
      className: bem.element('subtitle')
    },
      slideProps.subtitle
    )
  )
}
